<template>
  <b-modal
    id="modal-export-komship"
    ref="modal-export-komship"
    hide-header
    hide-footer
    centered
    dialog-class="modal-dialog-centered !max-w-[480px] !w-full mx-auto"
    content-class="!rounded-[16px] !border-0 shadow-lg overflow-hidden bg-white"
    body-class="!p-0"
  >
    <div class="p-6 bg-white">
      <!-- Header: Title & Close Button -->
      <div class="flex items-start justify-between">
        <h4 class="text-[18px] font-semibold text-[#22292F] m-0 leading-normal">
          {{ isBulk ? 'Export ke Data Order Komship Massal' : 'Export ke Data Order Komship' }}
        </h4>
        <button
          type="button"
          class="text-[#828282] hover:text-[#22292F] transition-colors cursor-pointer bg-transparent border-0 p-0 ml-3 inline-flex items-center justify-center focus:outline-none"
          @click="closeModal"
        >
          <feather-icon
            icon="XIcon"
            size="20"
          />
        </button>
      </div>

      <!-- Description / Body -->
      <p class="text-[#828282] text-[14px] leading-relaxed mt-2.5 mb-0 text-left">
        <template v-if="isBulk">
          Semua order yang dipilih dengan status
          <strong class="font-bold text-[#22292F]">Diterima</strong> akan diajukan untuk
          <strong class="font-bold text-[#22292F]">Pick Up</strong> dan masuk ke
          <strong class="font-bold text-[#22292F]">Data Order Komship</strong> kemudian
          diproses secara bersamaan.
        </template>
        <template v-else>
          Order yang dipilih akan masuk ke Data Order
          <strong class="font-bold text-[#22292F]">Komship</strong> dan dapat diproses
          untuk <strong class="font-bold text-[#22292F]">Ajukan Pick Up Order</strong>.
        </template>
      </p>

      <!-- Action Buttons -->
      <div class="flex items-center justify-end gap-3 mt-6">
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-[10px] text-sm font-medium border border-[#D8D6DE] bg-white hover:bg-gray-50 text-[#22292F] h-[40px] px-6 cursor-pointer shadow-sm transition-colors focus:outline-none"
          @click="closeModal"
        >
          Batal
        </button>
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-[10px] text-sm font-medium bg-[#F95031] hover:bg-[#E03F21] text-white border-0 h-[40px] px-6 cursor-pointer transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none"
          :disabled="isLoading"
          @click="confirmExport"
        >
          {{ isLoading ? 'Memproses...' : 'Konfirmasi' }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalExportKomship',
  props: {
    isBulk: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-export-komship')
    },
    confirmExport() {
      this.$emit('confirm')
    },
  },
}
</script>
